import Vue from 'vue'

import { LayoutPlugin, TabsPlugin, SpinnerPlugin } from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.min.css'
//import '../assets/scss/_variables_override.scss'
import 'bootstrap/scss/bootstrap.scss'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(LayoutPlugin)
Vue.use(TabsPlugin)
Vue.use(SpinnerPlugin)
//Vue.use(FormDatepickerPlugin)